module.exports = __webpack_public_path__ + "img/foto-christian-do-valle.jpg";